import React from "react"
import katex from "katex"
import "katex/dist/katex.min.css"

export interface IMathKatex {
    mixedContent: string
    className?: string
    classNameForMath?: string
}

/**
 * This will parse the combined html (or regular text) and math items into an array
 * 
 * @param mixedContent 
 * @returns 
 */
function parseHtmlWithMath(mixedContent) {
    let regex = /`([^`]+)`|([^`]+)/g
    let result: any[] = []
    let match

    mixedContent = mixedContent.replace(/\n/g, "<br/>")

    while ((match = regex.exec(mixedContent)) !== null) {
        let matchedContent

        if (match[1]) {
            matchedContent = (match[1] || "").trim()
            result.push({ type: 'math', content: matchedContent })
        } 
        else if (match[2]) {
            matchedContent = (match[2] || "").trim()
            result.push({ type: 'html', content: matchedContent })
        }
    }

    return result
}

/**
 * KaTeX rendering for the expression
 * @param mathExpression 
 * @returns 
 */
function renderMathToString(mathExpression) {
    return katex.renderToString(mathExpression, {throwOnError: false})
}

export default function MathKatex({mixedContent, className="", classNameForMath=""}: IMathKatex) {
    let parsedItems = parseHtmlWithMath(mixedContent)
    let html = parsedItems.reduce((acc, cur) => {
        let {type, content} = cur
        let m = renderMathToString(content)

        let innerHtml = type === "html" ? 
            `<span>${content}</span>`: 
            `<span class="${classNameForMath}">${renderMathToString(content)}</span>`
        return acc += innerHtml
    }, "")

    return (
        <div className={className} dangerouslySetInnerHTML={{__html: html}}/>
    )
}
